// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "877ee49e1c91d19761f2eff384ca8768256e645a/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};